import angular from 'angular';

import './power-stat-graph-index.css';

export class PowerStatGraphIndexController {
  /*@ngInject*/
  constructor($cookies){
    this.$cookies = $cookies;
    this.type = this.$cookies.get('power_stat_type') || 'event';
  }

  $onInit() {
  }

  changeType(type) {
    this.$cookies.put('power_stat_type', type);
    this.type = type;
    this.data.type = type;
  }
}

export default angular.module('leptonApp.powerStatGraphIndex', [])
  .component('powerStatGraphIndex', {
    template: require('./power-stat-graph-index.html'),
    controller: PowerStatGraphIndexController,
    bindings: {
      data: '='
    }
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/statistics_report/power-stat-graph/index/power-stat-graph-index.component.js